import log from 'loglevel';
import { defineStore } from 'pinia';
import { Country } from '@/interfaces/Payouts/Country';
import { LeaderboardService } from '@/api/services/LeaderboardService';
import { LeaderboardUser } from '@/interfaces/Leaderboard/LeaderboardUser';
import { LeaderboardResponse } from '@/interfaces/Leaderboard/LeaderboardResponse';
import { useAuthStore } from './AuthStore';

export const LeaderboardStore = defineStore('leaderboardStore', {
    state: () => ({
        loading: false,
        countries: [] as Country[],
        currentCountry: {} as Country,
        allTimeLeaderboard: [] as LeaderboardUser[],
        last7DaysLeaderboard: [] as LeaderboardUser[],
        last30DaysLeaderboard: [] as LeaderboardUser[],
    }),

    actions: {
        async initialize() {
            console.log('Initializing LeaderboardStore');
            try {
                // Only fetch leaderboard if user is logged in
                const authStore = useAuthStore();
                if (authStore.isUserLoggedIn()) {
                    await this.fetchLeaderboard();
                } else {
                    log.info("User not logged in, skipping leaderboard initialization");
                }
                
                console.log('LeaderboardStore initialized successfully');
                return true;
            } catch (error) {
                console.error('Error initializing LeaderboardStore:', error);
                return false;
            }
        },

        async fetchLeaderboard() {
            this.loading = true;
            
            try {
                const response = await LeaderboardService.getLeaderboard();
                
                // Use optional chaining and default values to handle potential undefined values
                this.allTimeLeaderboard = response?.leaderboard?.alltime ?? [];
                this.last7DaysLeaderboard = response?.leaderboard?.last7 ?? [];
                this.last30DaysLeaderboard = response?.leaderboard?.last30 ?? [];
                this.countries = response?.countries ?? [];
                this.currentCountry = response?.current_country ?? {} as Country;
            } catch (error) {
                log.error('Failed to fetch leaderboard:', error);
            } finally {
                this.loading = false;
            }
        },

        clearStoreData() {
            this.$reset();
        },
    },
});